import {
  Utensils,
  Car,
  Hotel,
  Ticket,
  ShoppingBag,
  MoreHorizontal,
  type LucideIcon,
} from "lucide-react";
import type { ExpenseCategory } from "@tabipla/shared";

interface CategoryConfig {
  icon: LucideIcon;
  color: string;
  bgColor: string;
  darkBgColor: string;
  textColor: string;
  darkTextColor: string;
}

export const EXPENSE_CATEGORIES: Record<ExpenseCategory, CategoryConfig> = {
  food: {
    icon: Utensils,
    color: "orange",
    bgColor: "bg-orange-100",
    darkBgColor: "dark:bg-orange-900/30",
    textColor: "text-orange-600",
    darkTextColor: "dark:text-orange-400",
  },
  transport: {
    icon: Car,
    color: "blue",
    bgColor: "bg-blue-100",
    darkBgColor: "dark:bg-blue-900/30",
    textColor: "text-blue-600",
    darkTextColor: "dark:text-blue-400",
  },
  accommodation: {
    icon: Hotel,
    color: "purple",
    bgColor: "bg-purple-100",
    darkBgColor: "dark:bg-purple-900/30",
    textColor: "text-purple-600",
    darkTextColor: "dark:text-purple-400",
  },
  activity: {
    icon: Ticket,
    color: "green",
    bgColor: "bg-green-100",
    darkBgColor: "dark:bg-green-900/30",
    textColor: "text-green-600",
    darkTextColor: "dark:text-green-400",
  },
  shopping: {
    icon: ShoppingBag,
    color: "pink",
    bgColor: "bg-pink-100",
    darkBgColor: "dark:bg-pink-900/30",
    textColor: "text-pink-600",
    darkTextColor: "dark:text-pink-400",
  },
  other: {
    icon: MoreHorizontal,
    color: "gray",
    bgColor: "bg-gray-100",
    darkBgColor: "dark:bg-gray-800",
    textColor: "text-gray-600",
    darkTextColor: "dark:text-gray-400",
  },
};

export const CATEGORY_LIST: ExpenseCategory[] = [
  "food",
  "transport",
  "accommodation",
  "activity",
  "shopping",
  "other",
];

/**
 * Get combined Tailwind classes for category styling
 */
export function getCategoryClasses(category: ExpenseCategory): string {
  const config = EXPENSE_CATEGORIES[category];
  return `${config.bgColor} ${config.darkBgColor} ${config.textColor} ${config.darkTextColor}`;
}
